import React from 'react';
import { Formik, Form } from 'formik';
import { Container, Grid, Radio, RadioGroup } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Button from 'components/atoms/Button/Button';
import FormControlChooseOption from 'components/atoms/FormControlChooseOption';
import { setActiveRadio } from 'utils/SetActiveToRadio';
import CustomTypography from 'components/atoms/CustomTypography';
import { fonts } from 'theme/Variables';
import { gender } from 'localdata/registerPage/steps/stepFour';
import { isDisabled } from '../../../utils/buttonFormIsDisabled';

const StepFour = ({ setValuesToFormData, nextStep }) => {
    return (
        <Container>
            <BoxWrapper mt="50">
                <Grid container justify="center">
                    <Grid item xs={12} md={4}>
                        <Formik
                            initialValues={{
                                gender: '',
                            }}
                            onSubmit={(values) => {
                                setValuesToFormData(values);
                                nextStep('stepFive');
                            }}
                        >
                            {({ values, handleChange, handleBlur, isValid }) => (
                                <Form>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <CustomTypography
                                            variant="h3"
                                            fontSize="2.6"
                                            customfont={fonts.secondary}
                                        >
                                            Your gender
                                        </CustomTypography>
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <RadioGroup
                                            name="gender"
                                            defaultValue={values.gender}
                                            value={values.gender}
                                            onChange={handleChange}
                                            className="w-100"
                                        >
                                            {gender.map(({ value, label, instruction, option }) => (
                                                <FormControlChooseOption
                                                    key={value}
                                                    value={value}
                                                    control={
                                                        <Radio color="secondary" label={label} />
                                                    }
                                                    label={label}
                                                    option={option}
                                                    instruction={instruction}
                                                    labelPlacement="start"
                                                    active={setActiveRadio(values.gender, value)}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </BoxWrapper>
                                    <BoxWrapper>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                            width="50"
                                            type="submit"
                                            disabled={isDisabled(values, isValid)}
                                        >
                                            Continue
                                        </Button>
                                    </BoxWrapper>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </BoxWrapper>
        </Container>
    );
};

export default StepFour;
